import { Recipes } from "@/types/recipes";
import { Products, Product } from "@/types/common";

export interface RootState {
  version: string;
}

export interface SearchState {
  recommendRecipes: Recipes | null;
  rankingRecipes: Recipes | null;
  searchKeywordRecipes: Recipes | null;
  tagGroups: TagGroups | null;
  products: Products | null;
  // WebApi以外
  keyword: string | null;
  sortType: string | null;
  tags: string | null;
  applianceList: Array<ApplianceData> | null;
}

/** 検索ソート種別 */
export const SEARCH_SORT_TYPE = {
  /** 新着順 */
  RECENT: "recent",
  /** 検索キーワード一致 */
  MATCH: "match",
  /** その他 */
  OTHER: ""
};

export type SEARCH_SORT_TYPE = typeof SEARCH_SORT_TYPE[keyof typeof SEARCH_SORT_TYPE];

export class DropdownItem {
  label: string;
  type: string;
  id: number;
  constructor() {
    this.label = "";
    this.type = "";
    this.id = -1;
  }
}

export class DropdownList {
  list: Array<DropdownItem>;
  constructor() {
    this.list = [];
  }
}

export class HistoryItem {
  id: number;
  label: string;
  constructor(id: number, label: string) {
    this.id = id;
    this.label = label;
  }
}

/** 文字列から検索ソート種別を取得する */
export const getSearchSortType = (type: string): SEARCH_SORT_TYPE => {
  switch (type) {
    case SEARCH_SORT_TYPE.RECENT:
      return SEARCH_SORT_TYPE.RECENT;
    case SEARCH_SORT_TYPE.MATCH:
      return SEARCH_SORT_TYPE.MATCH;
  }
  return SEARCH_SORT_TYPE.OTHER;
};

/** 検索レシピ種別 */
export const SEARCH_RECIPE_TYPE = {
  /** あなたにおすすめ */
  RECOMMEND: "search_recommend",
  /** あなたに似ている人に人気 */
  RANKING: "search_ranking",
  /** あなたにぴったり */
  TOPIC: "search_topic"
} as const;

export type SEARCH_RECIPE_TYPE = typeof SEARCH_RECIPE_TYPE[keyof typeof SEARCH_RECIPE_TYPE];

/** Appliance Category ID */
export const SEARCH_APPLIANCE_CATEGORY_ID = {
  /** 電子レンジ */
  MICRO_WAVE_OVEN: 88,
  /** 炊飯器 */
  RICE_COOKER: 101,
  /** 自動計量炊飯器 */
  RICE_COOKER_AUTO_WEIGHTING: 823,
  /** IHクッキングヒーター */
  IH_COOKING_HEATER: 129,
  /** 冷蔵庫 */
  REFRIGERATOR: 153,
  /** ホームベーカリー */
  HOME_BAKERY: 252,
  /** 卓上IH */
  DESKTOP_IH: 669,
  /** オートクッカー */
  AUTO_COKKER: 684
} as const;

export type SEARCH_APPLIANCE_CATEGORY_ID = typeof SEARCH_APPLIANCE_CATEGORY_ID[keyof typeof SEARCH_APPLIANCE_CATEGORY_ID];

/**
 * レシピ検索リクエストデータ
 */
export interface RequestSearchKeyword {
  keyword: string;
  sort: string;
  appliance: string;
  tags: Array<SearchTag>;
}

/**
 * レシピ検索リクエストデータ
 */
 export interface RequestSearchKeywordTags {
  keyword: string;
  sort: string;
  appliance: string;
  tags: Array<SearchTag>;
  tagGroups: TagGroups | null;
}

/**
 * 検索用タグデータ
 */
export class SearchTag {
  alias: string;
  description: string;
  id: number;
  name: string;
  constructor(alias: string, description: string, id: number, name: string) {
    this.alias = alias;
    this.description = description;
    this.id = id;
    this.name = name;
  }
}

/**
 * タググループ
 */
export interface TagGroups {
  tagGroups: Array<TagGroup>;
}

/**
 * タググループ
 */
export interface TagGroup {
  alias: string;
  description: string;
  selectable: number;
  operation: string | null;
  tags: Array<Tag>;
}

/**
 * タグ
 */
export interface Tag {
  id: number;
  name: string;
  image: string | null;
}

export class TagGroupInfo {
  public id: number;
  public tagGroup: TagGroup | null;
  public selected: Array<number>;
  constructor(tagGroup: TagGroup, id: number) {
    this.id = id;
    this.tagGroup = tagGroup;
    this.selected = [];
    this.selected.length = 0;
  }
}

/**
 * 検索用タグリストデータ
 */
export class SearchTags {
  public tags: Array<SearchTag>;
  constructor() {
    this.tags = [];
  }
}

export class ApplianceList {
  public applianceList: Array<ApplianceData>;
  constructor() {
    this.applianceList = [];
  }
}

export class ApplianceData {
  id: number;
  check: boolean;
  product: Product;

  constructor(id: number, check: boolean, product: Product) {
    this.id = id;
    this.check = check;
    this.product = product;
  }
}

export class SaveApplianceData {
  check: boolean;
  applianceId: string;
  geminiId: string;
  uniqueId: string;

  constructor(data: ApplianceData) {
    this.check = data.check;
    this.applianceId = data.product.applianceId;
    this.geminiId = data.product.geminiId;
    this.uniqueId = data.product.uniqueId;
  }
  setData = (data: ApplianceData) => {
    this.check = data.check;
    this.applianceId = data.product.applianceId;
    this.geminiId = data.product.geminiId;
    this.uniqueId = data.product.uniqueId;
  };
}

export class SaveApplianceList {
  applianceList: Array<SaveApplianceData>;
  constructor() {
    this.applianceList = [];
  }
  setData = (data: ApplianceList) => {
    data.applianceList.forEach(e => {
      this.applianceList.push(new SaveApplianceData(e));
    });
  };
}
